import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Freeze({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M9.33336 2.84881V0.333374H10.6667V2.84881L12.5571 1.16843L13.4429 2.16498L10.6667 4.63275L10.6667 10.6152L16.2805 13.8563L19.8058 12.6859L20.2259 13.9514L17.8254 14.7483L20.0038 16.006L19.3372 17.1607L17.1587 15.903L17.6688 18.3804L16.3628 18.6492L15.6138 15.011L10.6667 12.1548L10.6667 17.8673L13.4429 20.3351L12.5571 21.3316L10.6667 19.6513V22.1667H9.33336V19.6513L7.44293 21.3316L6.55711 20.3351L9.33336 17.8673L9.33336 12.1547L4.81912 14.7609L4.07009 18.3991L2.76415 18.1302L3.27418 15.6529L1.09575 16.9106L0.429083 15.7559L2.60752 14.4982L0.207054 13.7012L0.627179 12.4358L4.15245 13.6062L8.66654 11L4.15243 8.39382L0.627156 9.56423L0.207031 8.29881L2.60749 7.50184L0.42906 6.24413L1.09573 5.08943L3.27416 6.34714L2.76412 3.8698L4.07007 3.60093L4.8191 7.23911L9.33336 9.84542L9.33336 4.63275L6.55711 2.16498L7.44293 1.16843L9.33336 2.84881Z"
        fill={iconColor}
      />
      <Path
        d="M19.3373 4.83928L17.1589 6.097L17.6689 3.61966L16.3629 3.35079L15.6139 6.98897L11.6641 9.26939L12.9974 10.0392L16.2806 8.14367L19.8059 9.31408L20.226 8.04867L17.8255 7.2517L20.004 5.99398L19.3373 4.83928Z"
        fill={iconColor}
      />
    </Svg>
  );
}
